import { useCallback } from "react"
import { View } from "react-native"
import { useTheme } from "styled-rn"

import { NakamaSocketState } from "../../hooks/useNakama"
import { gameSlugToName } from "../../lib/gameMeta"
import { navigateMainNavigator } from "../../navigation/navigateMainNavigator"
import { BASE_PADDING, AnimatedPressableBase } from "../DesignSystem"
import { GameIcon } from "../Thumbnails/games/GameIcon"
import { PopoverTooltip } from "../popovers/PopoverTooltip"
import { NakamaIDAvatar } from "../profiles/NakamaIDAvatar"

export const InviteAvatar = (props: { invite: ReturnType<NakamaSocketState["invitesViaNakamaID"]["get"]> }) => {
  const theme = useTheme()

  const openInvite = useCallback(() => {
    if (props.invite) {
      navigateMainNavigator("PlayGame", { playGameSlug: props.invite.toGameplaySlug, gameSlug: props.invite.toGameSlug })
    }
  }, [props.invite])

  if (!props.invite) return null

  return (
    <View style={{ borderLeftColor: theme.g_bg, borderLeftWidth: 1, marginLeft: BASE_PADDING, borderStyle: "dashed" }} key="invite">
      <PopoverTooltip text={`Accept invite for a game of ${gameSlugToName(props.invite.toGameSlug)}`}>
        <AnimatedPressableBase onPress={openInvite} style={{ alignContent: "center", marginLeft: BASE_PADDING }}>
          <NakamaIDAvatar noLink size={30} nakamaID={props.invite.nakamaID} />
          <View
            style={{
              position: "absolute",
              top: -4,
              right: -4,
              width: 18,
              height: 18,
              borderRadius: 14,
              backgroundColor: theme.a_bg,
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <GameIcon
              gameslug={props.invite.toGameSlug as any}
              fg={theme.fg}
              bg={theme.a_bg}
              style={{ position: "relative", left: 2, height: 12, width: 12 }}
            />
          </View>
        </AnimatedPressableBase>
      </PopoverTooltip>
    </View>
  )
}
